import { Component } from '@angular/core';

@Component({
  selector: 'section-description',
  templateUrl: './section-description.component.html',
  styleUrls: ['./section-description.component.scss'],
  standalone: false,
})
export class SectionDescriptionComponent {}
